import React, { useState } from 'react';
import { View, Text, StyleSheet, Image } from 'react-native';
import { SafeAreaView, useSafeAreaInsets } from 'react-native-safe-area-context';
import { useRouter } from 'expo-router';
import { useSobriety } from '@/contexts/SobrietyContext';
import { useLanguage } from '@/contexts/LanguageContext';
import PageHeader from '@/components/PageHeader';
import PrimaryButton from '@/components/PrimaryButton';

export default function SobrietyCongratulationsScreen() {
  const router = useRouter();
  const { t } = useLanguage();
  const insets = useSafeAreaInsets();
  const { setupSobrietyToday } = useSobriety();
  const [isLoading, setIsLoading] = useState(false);

  const handleStartCounting = async () => {
    console.log('Starting sobriety count from today');

    setIsLoading(true);
    try {
      await setupSobrietyToday(async () => {
      });

      router.replace('/diary');
    } catch (error) {
      console.error('Failed to setup sobriety:', error);
      setIsLoading(false);
    }
  };

  return (
    <SafeAreaView style={styles.container} edges={['top']}>
      <PageHeader 
        title={t('sobriety.congratulations.title')} 
        onBack={() => router.back()}
        showBackButton={false}
        backgroundColor="#F0EEE4"
      />

      <View style={styles.content}>
        <View style={styles.illustrationContainer}>
          <Image
            source={require('@/assets/images/time-to-fly.png')}
            style={styles.illustrationImage}
            resizeMode="contain"
          />
        </View>

        <Text style={styles.congratsTitle}>
          {t('sobriety.congratulations.mainTitle')}
        </Text>

        <Text style={styles.subtitle}>
          {t('sobriety.congratulations.subtitle')}
        </Text>
      </View>

      <View style={[styles.buttonContainer, { paddingBottom: insets.bottom + 24 }]}>
        <PrimaryButton
          title={t('sobriety.congratulations.button')}
          onPress={handleStartCounting}
          loading={isLoading}
        />
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F0EEE4',
  },
  content: {
    flex: 1,
    paddingHorizontal: 40,
    justifyContent: 'center',
    alignItems: 'center',
    gap: 16,
  },
  illustrationContainer: {
    width: 260,
    height: 260,
    marginBottom: 16,
  },
  illustrationImage: {
    width: '100%',
    height: '100%',
  },
  congratsTitle: {
    fontSize: 24,
    fontFamily: 'Sentient-Regular',
    color: '#151515',
    textAlign: 'center',
    lineHeight: 29,
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 14,
    fontFamily: 'Inter_400Regular',
    color: '#151515',
    textAlign: 'center',
    lineHeight: 20,
  },
  buttonContainer: {
    paddingHorizontal: 24,
  },
});
